export const cutTextAtLength = (text: string, length: number) => {
	if (text.length <= length) return text;

	const textArray = text.substring(0, length - 2).split(' ');
	textArray.pop();

	return textArray.join(' ').replace(/\.*$/, '...');
};